export const GAINSIGHT_PX_EVENT_BLUEPRINT_FILE_UPLOADED = 'Blueprint File Uploaded';
export const GAINSIGHT_PX_EVENT_MAP_PIN_ADDED = 'Map Pin Added';
export const GAINSIGHT_PX_EVENT_MAP_PIN_LOCATION_UPDATED = 'Map Pin Location Updated';
export const GAINSIGHT_PX_EVENT_MAP_PIN_DELETED = 'Map Pin Deleted';
export const GAINSIGHT_PX_EVENT_PRODUCT_TOOLTIP_OPENED = 'Product Tooltip Opened';
export const GAINSIGHT_PX_EVENT_MEASUREMENT_INSTRUCTION_SELECTED = 'Measurement Instruction Selected';
export const GAINSIGHT_PX_EVENT_PRODUCT_SELECTED = 'Product Selected';
